export var WidgetType;
(function (WidgetType) {
    WidgetType["SingleValue"] = "single-value";
    WidgetType["LineChart"] = "line-chart";
    WidgetType["Divider"] = "divider";
    WidgetType["Image"] = "image";
    WidgetType["Funnel"] = "funnel";
})(WidgetType || (WidgetType = {}));
export const MAX_WIDGETS_PER_DASHBOARD = {
    metricWidgets: {
        limit: 100,
        types: [WidgetType.SingleValue, WidgetType.LineChart],
    },
    nonMetricWidgets: {
        limit: 50,
        types: [WidgetType.Divider, WidgetType.Image],
    },
};
export var DashboardExportType;
(function (DashboardExportType) {
    DashboardExportType["Pdf"] = "pdf";
    DashboardExportType["Xlsx"] = "xlsx";
    DashboardExportType["Html"] = "html";
})(DashboardExportType || (DashboardExportType = {}));
export var DashboardTemplateType;
(function (DashboardTemplateType) {
    DashboardTemplateType["Blank"] = "Blank";
    DashboardTemplateType["PagePerformance"] = "PAGE_PERFORMANCE";
    DashboardTemplateType["SegmentPerformance"] = "SEGMENT_PERFORMANCE";
})(DashboardTemplateType || (DashboardTemplateType = {}));
export var NRTDashboardTemplateType;
(function (NRTDashboardTemplateType) {
    NRTDashboardTemplateType["ErrorMonitoring"] = "ErrorMonitoring";
    NRTDashboardTemplateType["Blank"] = "Blank";
})(NRTDashboardTemplateType || (NRTDashboardTemplateType = {}));
export var SegmentStacking;
(function (SegmentStacking) {
    SegmentStacking["Override"] = "override";
    SegmentStacking["Intersect"] = "intersect";
})(SegmentStacking || (SegmentStacking = {}));
//# sourceMappingURL=dashboard.model.js.map